import { Component, CSP_NONCE, OnInit, SimpleChanges } from '@angular/core';
import { AssetData } from '../../models/assetData.model';
import { DashboardService } from '../../services/dashboard.service';
import { AreaService } from '../../services/area.service';
import { RegionService } from '../../services/region.service';
import { Region } from '../../models/region.model';
import { Area } from '../../models/area.model';
import { ToastrService } from 'ngx-toastr';
import { ChartConfiguration } from 'chart.js';
import { AssetsCounts } from '../../models/assetsCounts.model';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { ChecklistItem } from '../../models/checklist-item.model';
import { Feeder11Service } from '../../services/feeder11.service';
import { SubstationService } from '../../services/substation.service';
import { TransmissionStationService } from '../../services/transmission-station.service';
import { min } from 'rxjs';
import { PermissionsService } from '../../services/permissions.service';
import { AuthService } from '../../services/auth.service';
import { SubGeographicalRegionService } from '../../services/sub-geographical-region.service';
import { AcLineSegmentService } from '../../services/ac-line-segment.service';
import { CimSubstationService } from '../../services/cim-substation.service';
import { SubstationTemplateStat } from '../../models/substation-template-stat.model';
import { EquipmentListService } from '../../services/equipment-list.service';

//this component is currently not being used anywhere
@Component({
  selector: 'lib-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  standalone: false,
})
export class DashboardComponent implements OnInit {
  assetsCounts: AssetsCounts = new AssetsCounts();
  customersData: AssetData = new AssetData(null, 'Customers');
  buildingsData: AssetData = new AssetData(null, 'Buildings');
  deviceData: AssetData = new AssetData(null, 'Device');
  buildingsSalesManagementData: AssetData = new AssetData();
  buildingsDoughnutData: AssetData = new AssetData();
  distributionSubstationsData: AssetData = new AssetData(null, 'Transformers');
  poleData: AssetData = new AssetData(null, 'Pole');
  isPrimaryGroupVisibleTaggedAssets: boolean = true;

  // ovo obrisati kada se bude brisala nova metoda getAnalyticsOverview()
  stationDataLoadedCount: number = 0;
  totalStationCalls: number = 3;

  poleCount: number = 0;
  mvPoleCount: number = 0;
  hvPoleCount: number = 0;
  tsData: AssetData = new AssetData(null, 'Ts');
  substationData: AssetData = new AssetData(null, 'Ss');
  sectionDefinitionData: AssetData = new AssetData(null, 'SD');
  f11Data: AssetData = new AssetData(null, 'F11');
  f33Data: AssetData = new AssetData(null, 'F33');
  feedersData: AssetData = new AssetData(null, 'Feeders');

  cimFeedersData: AssetData = new AssetData(null, 'Feeders');
  mainFeederData: AssetData = new AssetData(null, 'Main');
  primaryFeederData: AssetData = new AssetData(null, 'Primary');
  secondaryFeederData: AssetData = new AssetData(null, 'Secondary');
  substationTemplateStats: SubstationTemplateStat[] = [];
  equipmentData: AssetData = new AssetData(null, 'Equipment');
  transformersDataSalesManagement: AssetData = new AssetData(
    null,
    'Transformers'
  );
  polesDataSalesManagement: AssetData = new AssetData(null, 'Poles');
  customersDataSalesManagement: AssetData = new AssetData(null, 'Customers');
  increasement: number = 0;

  areaIds: number[] = [];
  selectedSubgeographicalRegions: number[] = [];
  regions: Region[] = [];
  areas: Area[] = [];

  graphType: string = 'Daily';
  graphDateType: string = 'LastUpdateTime';
  page: number = 0;
  pageSize: number = 6;
  graphData: any = { labels: ['-'] };
  lineGraphData: any;
  formatedGraphData: ChartConfiguration<'bar'>['data'] = { datasets: [] };
  showFilterModal = false;
  activeTab: 'region' | 'area' | 'date' = 'region';
  searchText: string = '';
  filteredRegions = [...this.regions];
  filteredAreas = [...this.areas];
  selectedAll: boolean = true;
  selectedDateFrom: any;
  selectedDateTo: any;
  activeDateFilter: string = 'custom';
  filters: ChecklistItem[] = [];

  constructor(
    private dashboardService: DashboardService,
    private areaService: AreaService,
    private regionService: RegionService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private datePipe: DatePipe,
    private f11Service: Feeder11Service,
    private ssService: SubstationService,
    private tsService: TransmissionStationService,
    public permissionsService: PermissionsService,
    private authService: AuthService,
    private subGeographicalRegionService: SubGeographicalRegionService,
    private acLineSegmentService: AcLineSegmentService,
    private cimSubstationService: CimSubstationService,
    private equipmentListService: EquipmentListService,
  ) {}

  get hasCim(): boolean {
    return this.authService.hasCimDataIntegration;
  }

  ngOnInit(): void {
    if (this.hasCim) {
      this.getGeoAndSubGeoRegions();
    } else {
      this.getRegions();
    }
  }

  private getRegions() {
    this.regionService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.regions = responseData.data;
          this.regions.forEach(function (region) {
            region.isSelectable = true;
            region.checked = true;
          });
          this.getAreas();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  private getAreas() {
    this.areaService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.areas = responseData.data;
          this.areas.forEach(function (area) {
            area.isSelectable = true;
            area.checked = true;
          });
          this.areas = this.areas.filter((x) =>
            this.regions
              .filter((y) => y.checked == true)
              .map((x) => x.id)
              .includes(x.regionId)
          );
          this.reloadDashboard();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  private getGeoAndSubGeoRegions() {
    this.subGeographicalRegionService.getAllForMappings().subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          const data = responseData.data ?? [];

          const seen = new Set<number>();
          this.regions = data
            .filter(
              (x: any) =>
                x.geographicalRegion?.id &&
                !seen.has(x.geographicalRegion.id) &&
                seen.add(x.geographicalRegion.id)
            )
            .map((x: any) => ({
              id: x.geographicalRegion.id,
              name: x.geographicalRegion.name,
              checked: true,
              isSelectable: true,
            })) as any;

          this.areas = data.map((x: any) => ({
            id: x.id,
            name: x.name,
            regionId: x.geographicalRegion?.id,
            regionName: x.geographicalRegion?.name,
            checked: true,
            isSelectable: true,
          })) as any;

          this.reloadDashboard();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  reloadDashboard() {
    const checkedFilterIds = this.areas
      .filter((x) => x.checked == true)
      .map((x) => x.id);

    if (this.hasCim) {
      this.selectedSubgeographicalRegions = checkedFilterIds;
      this.areaIds = [];
    } else {
      this.areaIds = checkedFilterIds;
      this.selectedSubgeographicalRegions = [];
    }
    // this.dtsIds = [];
    // this.resetLabel = !this.resetLabel;
    this.getGraphData([0, this.graphType]);
    this.getOperationsAnalytics([0, 'Daily']);
    this.getAnalyticsOverview();
    // this.getAnalyticsOverviewWithDtIds();
    this.dashboardService.getAssetsCounts(this.areaIds).subscribe({
      next: (data) => {
        this.assetsCounts = new AssetsCounts(data?.body?.data);
      },
      error: (error) => console.log(error.statusText),
    });
  }

  mapFilterLabels: Record<string, string> = {
    'Date From': 'COMMON.DATE_FROM',
    'Date To': 'COMMON.DATE_TO',
    District: 'COMMON.UT.SINGLE',
  };

  openFilterModal() {
    this.onSearchChange();
    this.showFilterModal = !this.showFilterModal;
  }

  onRegionChange(region: any) {
    this.areas.forEach((area) => {
      if (area.regionId === region.id) {
        area.checked = region.checked;
      }
    });

    this.updateSelectedAllState();
  }

  onAreaChange(area: any) {
    const regionAreas = this.areas.filter((a) => a.regionId === area.regionId);
    const region = this.regions.find((r) => r.id === area.regionId);
    if (!region) return;

    region.checked = regionAreas.every((a) => a.checked);

    this.updateSelectedAllState();
  }

  private updateSelectedAllState() {
    const allRegionsSelected = this.regions.every((r) => r.checked);
    const allAreasSelected = this.areas.every((a) => a.checked);
    this.selectedAll = allRegionsSelected && allAreasSelected;
  }

  setActiveTab(tab: 'region' | 'area' | 'date') {
    this.activeTab = tab;
    this.searchText = '';
    this.onSearchChange();
  }

  onSearchChange() {
    const text = this.searchText.toLowerCase();
    if (this.activeTab === 'region') {
      this.filteredRegions = this.regions.filter((r) =>
        r.name.toLowerCase().includes(text)
      );
    } else if (this.activeTab === 'area') {
      this.filteredAreas = this.areas.filter((a) =>
        a.name.toLowerCase().includes(text)
      );
    }
  }

  selectAll() {
    this.areas.forEach((area) => {
      area.checked = true;
    });

    this.regions.forEach((region) => {
      region.checked = true;
    });

    this.selectedAll = true;
  }

  deselectAll() {
    this.areas.forEach((area) => {
      area.checked = false;
    });

    this.regions.forEach((region) => {
      region.checked = false;
    });

    this.selectedAll = false;
  }

  setDateFilter(filter: string) {
    this.activeDateFilter = filter;

    const today = new Date();
    let from: Date | null;
    let to: Date | null;

    switch (filter) {
      case 'today':
        from = new Date(today);
        to = new Date(today);
        break;
      case 'yesterday':
        from = new Date(today);
        from.setDate(today.getDate() - 1);
        to = new Date(from);
        break;
      case 'this_week':
        const day = today.getDay() || 7;
        from = new Date(today);
        from.setDate(today.getDate() - day + 1);
        to = new Date(today);
        break;
      case 'this_month':
        from = new Date(today.getFullYear(), today.getMonth(), 1);
        to = new Date(today);
        break;
      case 'this_year':
        from = new Date(today.getFullYear(), 0, 1);
        to = new Date(today);
        break;
      case 'custom':
      default:
        from = null;
        to = null;
        break;
    }

    this.selectedDateFrom = from
      ? this.datePipe.transform(from, 'yyyy-MM-dd')
      : null;
    this.selectedDateTo = to ? this.datePipe.transform(to, 'yyyy-MM-dd') : null;
  }

  onAddFilter() {
    const districtProp = this.mapFilterLabels['District'];
    const dateFromProp = this.mapFilterLabels['Date From'];
    const dateToProp = this.mapFilterLabels['Date To'];

    if (
      this.selectedDateFrom &&
      this.selectedDateTo &&
      this.selectedDateFrom > this.selectedDateTo
    ) {
      this.toastr.error('The From date must be earlier than the To date.');
      return;
    }

    const propsToReplace = [districtProp, dateFromProp, dateToProp];

    this.filters = this.filters.filter(
      (f) => !propsToReplace.includes(f.property)
    );

    const selectedAreas = this.areas.filter((a) => a.checked).length;
    if (selectedAreas !== this.areas.length) {
      this.filters.push(
        new ChecklistItem(districtProp, selectedAreas.toString())
      );
    }

    if (this.selectedDateFrom) {
      this.filters.push(new ChecklistItem(dateFromProp, this.selectedDateFrom));
    }
    if (this.selectedDateTo) {
      this.filters.push(new ChecklistItem(dateToProp, this.selectedDateTo));
    }

    this.showFilterModal = false;
  }

  removeFilter(checklistItem: ChecklistItem) {
    const index = this.filters.indexOf(checklistItem, 0);
    if (index > -1) {
      this.filters.splice(index, 1);
    }

    if (checklistItem.property == this.mapFilterLabels['District']) {
      this.selectAll();
    }

    if (checklistItem.property == this.mapFilterLabels['Date From']) {
      this.selectedDateFrom = null;
      this.activeDateFilter = 'custom';
    }

    if (checklistItem.property == this.mapFilterLabels['Date To']) {
      this.selectedDateTo = null;
      this.activeDateFilter = 'custom';
    }

    this.reloadDashboard();
  }

  resetFilter() {
    this.activeDateFilter = 'custom';
    this.selectedDateFrom = null;
    this.selectedDateTo = null;
    this.filters = [];
    this.selectAll();
    this.reloadDashboard();
  }

  getAnalyticsOverview() {
    const obj = {
      areaIds: this.areaIds,
      subgeographicalRegionIds: this.selectedSubgeographicalRegions,
      dateFrom:
        this.filters.find(
          (f) => f.property === this.mapFilterLabels['Date From']
        )?.selectedValue || null,
      dateTo:
        this.filters.find((f) => f.property === this.mapFilterLabels['Date To'])
          ?.selectedValue || null,
      showAllNewEntries: !this.permissionsService.isCustomerNewEntryBreakdownAllowed,
    };

    this.dashboardService.getAnalyticsOverviewBuilding(obj).subscribe({
      next: (data) => {
        this.buildingsData = new AssetData(data?.body?.data, 'Buildings');
        this.buildingsData.totalCount = Number.isNaN(
          this.buildingsData.totalCount
        )
          ? 0
          : this.buildingsData.totalCount;
        this.buildingsSalesManagementData = JSON.parse(
          JSON.stringify(this.buildingsData)
        );
        this.buildingsDoughnutData = JSON.parse(
          JSON.stringify(this.buildingsData)
        );
        this.buildingsSalesManagementData.items =
          this.buildingsSalesManagementData.items.filter(
            (x) => x.key != 'New' && x.key != 'Existing'
          );

        this.buildingsDoughnutData.items =
          this.buildingsDoughnutData.items.filter(
            (x) => x.key === 'Tagged' || x.key === 'Inaccessible'
          );
      },
      error: (error) => console.log(error.statusText),
    });

    this.dashboardService.getAnalyticsOverviewCustomer(obj).subscribe({
      next: (data) => {
        (this.customersData = new AssetData({
          assetName: 'Customers',
          totalCount:
            data?.body?.data?.items?.reduce(
              (sum: number, item: { count: number }) => sum + item.count,
              0
            ) ?? 0,
          previousMonthTotal: data?.body?.data?.previousMonthTotal ?? 0,
          countIncrease: data?.body?.data?.countIncrease ?? 0,
          increasePercentage: data?.body?.data?.increasePercentage ?? 0,
          items:
            data?.body?.data?.items?.map(
              (item: { name: string; count: number; isNew: boolean }) => ({
                key: item.name,
                value: item.count,
                isNew: item.isNew,
              })
            ) ?? [],
          subItems: [],
        })
      )
    },
      error: (error) => console.log(error.statusText),
    });

    this.dashboardService.getAnalyticsOverviewPole(obj).subscribe({
      next: (data) => {
        this.poleData = new AssetData({
          assetName: 'Poles',
          totalCount:
            (data?.body?.data.ltPolesCount ?? 0) +
            (data?.body?.data.mvPolesCount ?? 0) +
            (data?.body?.data.hvPolesCount ?? 0),
          previousMonthTotal: data?.body?.data?.previousMonthTotal ?? 0,
          countIncrease: data?.body?.data?.countIncrease ?? 0,
          increasePercentage: data?.body?.data?.increasePercentage ?? 0,
          items: ['ltPoles', 'mvPoles', 'hvPoles'].map((key) => ({
            key,
            value: data?.body?.data?.[`${key}Count`] ?? 0,
          })),
          subItems: [],
        });
      },
      error: (error) => console.log(error.statusText),
    });

    if (!this.hasCim) {
      this.dashboardService.getAnalyticsOverviewDt(obj).subscribe({
        next: (data) => {
          this.distributionSubstationsData = new AssetData(
            data?.body?.data,
            'Transformers'
          );
        },
        error: (error) => console.log(error.statusText),
      });
    }

    if (this.hasCim) {
      this.acLineSegmentService.getV3FeederStats(obj).subscribe({
        next: (data) => {
          const responseData = data?.body?.data;
          if (!responseData) {
            return;
          }
          const main = responseData.mainFeederCount ?? 0;
          const primary = responseData.primaryFeederCount ?? 0;
          const secondary = responseData.secondaryFeederCount ?? 0;

          this.cimFeedersData = new AssetData({
            assetName: 'Feeders',
            totalCount: main + primary ,
            previousMonthTotal: responseData.previousMonthTotal ?? 0,
            countIncrease: responseData.countIncrease ?? 0,
            increasePercentage: responseData.increasePercentage ?? 0,
            items: [
              { key: 'main', value: main },
              { key: 'primary', value: primary },
              { key: 'secondary', value: secondary }
            ]
          });

          this.mainFeederData = new AssetData({
            assetName: 'Main',
            totalCount: main,
            previousMonthTotal: responseData.previousMonthTotalMain ?? 0,
            countIncrease: responseData.countIncreaseMain ?? 0,
            increasePercentage: responseData.increasePercentageMain ?? 0,
          });

          this.primaryFeederData = new AssetData({
            assetName: 'Primary',
            totalCount: primary,
            previousMonthTotal: responseData.previousMonthTotalPrimary ?? 0,
            countIncrease: responseData.countIncreasePrimary ?? 0,
            increasePercentage: responseData.increasePercentagePrimary ?? 0,
          });

          this.secondaryFeederData = new AssetData({
            assetName: 'Secondary',
            totalCount: secondary,
            previousMonthTotal: responseData.previousMonthTotalSecondary ?? 0,
            countIncrease: responseData.countIncreaseSecondary ?? 0,
            increasePercentage: responseData.increasePercentageSecondary ?? 0,
          });
        },
        error: (error) => console.log(error.statusText),
      });
    } else {
      this.f11Service.getV3FeederStats(obj).subscribe({
        next: (data) => {
          const responseData = data?.body?.data;
          if (!responseData) {
            return;
          }
          this.feedersData = new AssetData({
            assetName: 'Feeders',
            totalCount: responseData.feeder11Count + responseData.feeder33Count,
            previousMonthTotal: responseData.previousMonthTotal ?? 0,
            countIncrease: responseData.countIncrease ?? 0,
            increasePercentage: responseData.increasePercentage ?? 0,
            items: ['feeder33', 'feeder11'].map((key) => ({
              key,
              value: responseData?.[`${key}Count`] ?? 0
            })),
            subItems: responseData.subItems
          });

          this.f11Data = new AssetData({
            assetName: 'F11',
            totalCount: responseData.feeder11Count,
            previousMonthTotal: responseData.previousMonthTotalF11 ?? 0,
            countIncrease: responseData.countIncreaseF11 ?? 0,
            increasePercentage: responseData.increasePercentageF11 ?? 0,
          });

          this.f33Data = new AssetData({
            assetName: 'F33',
            totalCount: responseData.feeder33Count,
            previousMonthTotal: responseData.previousMonthTotalF33 ?? 0,
            countIncrease: responseData.countIncreaseF33 ?? 0,
            increasePercentage: responseData.increasePercentageF33 ?? 0,
          });
        }
      })
    }

    this.ssService.getV3SubstationStats(obj).subscribe({
      next: (data) => {
        const responseData = data?.body?.data;
        this.substationData = new AssetData(responseData, "Substations");
      }
    })

    this.tsService.getV3TsStats(obj).subscribe({
      next: (data) => {
        const responseData = data?.body?.data;
        this.tsData = new AssetData(responseData, "Transmission Stations");
      }
    })

    if (this.hasCim) {
      this.cimSubstationService.getV3SubstationTemplateStats(obj).subscribe({
        next: (data) => {
          const responseData = data?.body?.data ?? [];
          this.substationTemplateStats = responseData.map(
            (item: any) => new SubstationTemplateStat(item)
          );
        },
        error: (error) => console.log(error.statusText),
      });

      this.equipmentListService.getV3EquipmentStats(obj).subscribe({
        next: (data) => {
          const responseData = data?.body?.data;
          this.equipmentData = new AssetData({
            assetName: 'Equipment',
            totalCount: responseData?.count ?? 0,
            previousMonthTotal: responseData?.previousMonthTotal ?? 0,
            countIncrease: responseData?.countIncrease ?? 0,
            increasePercentage: responseData?.increasePercentage ?? 0,
          });
        },
        error: (error) => console.log(error.statusText),
      });
    } else {
      this.substationTemplateStats = [];
    }
  }


  checkStationDataLoaded() {
    this.stationDataLoadedCount++;

    if (this.stationDataLoadedCount === this.totalStationCalls) {
      this.calculateNetworkStructure();
    }
  }

  calculateNetworkStructure() {
    const tsCount = this.tsData?.totalCount ?? 0;
    const injectionSubstationCount = this.substationData?.totalCount ?? 0;
    const distributionSubstationCount =
      this.distributionSubstationsData?.totalCount ?? 0;

    const totalStationsCount =
      tsCount + injectionSubstationCount + distributionSubstationCount;

    if (totalStationsCount === 0) {
      return;
    }

    const originalTsCount = tsCount;
    const originalInjectionCount = injectionSubstationCount;
    const originalDistributionCount = distributionSubstationCount;

    const calculatedTsCount = Math.round(totalStationsCount * 0.1); // 10%
    const calculatedInjectionCount = Math.round(totalStationsCount * 0.2); // 20%
    const calculatedDistributionCount =
      totalStationsCount - calculatedTsCount - calculatedInjectionCount; // 70%

    this.tsData = new AssetData({
      assetName: 'Transmission Stations',
      totalCount: calculatedTsCount,
      previousMonthTotal: this.tsData.previousMonthTotal,
      countIncrease: this.tsData.countIncrease,
      items:
        this.tsData.items?.map((item: any) => ({
          key: item.key,
          value:
            originalTsCount > 0
              ? Math.round(item.value * (calculatedTsCount / originalTsCount))
              : 0,
          translationKey: item.translationKey,
          share: item.share,
          isNew: item.isNew,
        })) ?? [],
      subItems: this.tsData.subItems ?? [],
    });

    this.substationData = new AssetData({
      assetName: 'Injection Substations',
      totalCount: calculatedInjectionCount,
      previousMonthTotal: this.substationData.previousMonthTotal,
      countIncrease: this.substationData.countIncrease,
      items:
        this.substationData.items?.map((item: any) => ({
          key: item.key,
          value:
            originalInjectionCount > 0
              ? Math.round(
                  item.value *
                    (calculatedInjectionCount / originalInjectionCount)
                )
              : 0,
          translationKey: item.translationKey,
          share: item.share,
          isNew: item.isNew,
        })) ?? [],
      subItems: this.substationData.subItems ?? [],
    });

    this.distributionSubstationsData = new AssetData({
      assetName: 'Distribution Substations',
      totalCount: calculatedDistributionCount,
      previousMonthTotal: this.distributionSubstationsData.previousMonthTotal,
      countIncrease: this.distributionSubstationsData.countIncrease,
      items:
        this.distributionSubstationsData.items?.map((item: any) => ({
          key: item.key,
          value:
            originalDistributionCount > 0
              ? Math.round(
                  item.value *
                    (calculatedDistributionCount / originalDistributionCount)
                )
              : 0,
          translationKey: item.translationKey,
          share: item.share,
          isNew: item.isNew,
        })) ?? [],
      subItems: this.distributionSubstationsData.subItems ?? [],
    });
  }

  getOperationsAnalytics(eventData: [number, string]) {
    const [chartPage, period] = eventData;
    let obj = {
      page: chartPage,
      pageSize: this.pageSize,
      graphType: period,
    };
    this.dashboardService.getOperationsAnalytics(obj).subscribe({
      next: (data) => {
        this.lineGraphData = this.formatLineGraphData(data.body);
      },
      error: (error) => console.log(error.statusText),
    });
  }

  formatLineGraphData(data: any) {
    let formatedGraphData = {
      labels: data?.labels ? data.labels : [],
      datasets: [
        {
          data: data?.surveysCount ? data.surveysCount : [],
          label: 'Surveys',
          fill: true,
          tension: 0.4,
          backgroundColor: 'rgba(16, 70, 80, 1)',
          pointBackgroundColor: 'rgba(16, 70, 80, 1)',
          borderColor: 'rgba(16, 70, 80, 1)',
          pointRadius: 4,
          borderRadius: 6,
        },
        {
          data: data?.installationsCount ? data.installationsCount : [],
          label: 'Installations',
          fill: true,
          tension: 0.4,
          backgroundColor: 'rgba(6, 129, 117, 1)',
          pointBackgroundColor: 'rgba(6, 129, 117, 1)',
          borderColor: 'rgba(6, 129, 117, 1)',
          pointRadius: 4,
          borderRadius: 6,
        },
      ],
    };

    return formatedGraphData;
  }

  // formatLineGraphData(data: any, period: string) {
  //   let minValue = 0;
  //   let maxValue = 5;
  //   if (period === 'Monthly') {
  //     minValue = 5;
  //     maxValue = 100;
  //   } else if (period === 'Yearly') {
  //     minValue = 100;
  //     maxValue = 500;
  //   }

  //   const generateRandomData = (labelsCount: number) => {
  //     return Array.from({ length: labelsCount }, () =>
  //       Math.floor(Math.random() * (maxValue - minValue + 1)) + minValue
  //     );
  //   };

  //   let formatedGraphData = {
  //     labels: data?.labels ? data.labels : [],
  //     datasets: [
  //       {
  //         data: generateRandomData(data?.labels?.length || 0),
  //         label: 'Surveys',
  //         fill: true,
  //         tension: 0.4,
  //         backgroundColor: 'rgba(16, 70, 80, 1)',
  //         pointBackgroundColor: 'rgba(16, 70, 80, 1)',
  //         borderColor: 'rgba(16, 70, 80, 1)',
  //         pointRadius: 4,
  //         borderRadius: 6,
  //       },
  //       {
  //         data: generateRandomData(data?.labels?.length || 0),
  //         label: 'Installations',
  //         fill: true,
  //         tension: 0.4,
  //         backgroundColor: 'rgba(6, 129, 117, 1)',
  //         pointBackgroundColor: 'rgba(6, 129, 117, 1)',
  //         borderColor: 'rgba(6, 129, 117, 1)',
  //         pointRadius: 4,
  //         borderRadius: 6,
  //       },
  //     ],
  //   };

  //   return formatedGraphData;
  // }

  toggleTaggedAssetCategory(value: boolean) {
    if (this.isPrimaryGroupVisibleTaggedAssets === value) return;
    this.isPrimaryGroupVisibleTaggedAssets = value;
    this.getGraphData([0, this.graphType]);
  }

  getGraphData(eventData: [number, string]) {
    const [chartPage, period] = eventData;
    this.graphType = eventData[1];
    var request = {
      page: chartPage,
      graphDataType: period,
      graphDateType: this.graphDateType,
      areaIds: this.areaIds,
      subgeographicalRegionIds: this.selectedSubgeographicalRegions,
    };
    this.dashboardService.getGraphData(request).subscribe({
      next: (data) => {
        this.graphData = this.formatGraphData(data.body, this.isPrimaryGroupVisibleTaggedAssets);
        // this.graphData = this.formatGraphData(data.body, period);
      },
      error: (error) => console.log(error.statusText),
    });
  }

  // ova metoda ce se koristi kada se ne budu hardcodovale vrednosti na grafiku

  formatGraphData(data: any, isPrimary: boolean | null) {
    const labels = data?.data?.labels || [];
    const zeros = Array.from({ length: labels.length }, () => 0);

    const primary = [
      {
        data: data?.data?.customersCount ? data.data.customersCount : [],
        label: this.translate.instant('DASHBOARD.ASSET_BREAKDOWN.CUSTOMERS'),
        borderRadius: 10,
        borderWidth: 0,
        backgroundColor: 'rgba(71, 154, 63, 1)',
        hoverBackgroundColor: 'rgba(71, 154, 63, 1)',
        barPercentage: 0.6,
      },
      {
        data: data?.data?.buildingsCount ? data.data.buildingsCount : [],
        label: this.translate.instant('DASHBOARD.ASSET_BREAKDOWN.BUILDINGS'),
        borderRadius: 10,
        borderWidth: 0,
        backgroundColor: 'rgba(188, 188, 3, 1)',
        hoverBackgroundColor: 'rgba(188, 188, 3, 1)',
        barPercentage: 0.6,
      },
      {
        data: data?.data?.dtsCount ? data.data.dtsCount : [],
        label: this.translate.instant(
          'DASHBOARD.ASSET_BREAKDOWN.DISTRIBUTION_SUBSTATIONS'
        ),
        borderRadius: 10,
        borderWidth: 0,
        backgroundColor: 'rgba(96, 149, 27, 1)',
        hoverBackgroundColor: 'rgba(96, 149, 27, 1)',
        barPercentage: 0.6,
      },
      {
        data: data?.data?.polesCount ? data.data.polesCount : [],
        label: this.translate.instant('DASHBOARD.ASSET_BREAKDOWN.POLES'),
        borderRadius: 10,
        borderWidth: 0,
        backgroundColor: 'rgba(108, 46, 64, 1)',
        hoverBackgroundColor: 'rgba(108, 46, 64, 1)',
        barPercentage: 0.6,
      },
    ];

    const secondary = [
      {
        data: zeros,
        label: this.translate.instant(
          'DASHBOARD.ASSET_BREAKDOWN.TRANSMISSION_STATIONS'
        ),
        borderRadius: 5,
        borderWidth: 0,
        backgroundColor: 'rgba(192, 52, 56, 1)',
        hoverBackgroundColor: 'rgba(192, 52, 56, 1)',
        barPercentage: 0.9,
      },
      {
        data: zeros,
        label: this.translate.instant(
          'DASHBOARD.ASSET_BREAKDOWN.INJECTION_SUBSTATIONS'
        ),
        borderRadius: 5,
        borderWidth: 0,
        backgroundColor: 'rgba(237, 99, 0, 1)',
        hoverBackgroundColor: 'rgba(237, 99, 0, 1)',
        barPercentage: 0.9,
      },
      {
        data: zeros,
        label: this.translate.instant('DASHBOARD.ASSET_BREAKDOWN.FEEDERS'),
        borderRadius: 5,
        borderWidth: 0,
        backgroundColor: 'rgba(8, 63, 114, 1)',
        hoverBackgroundColor: 'rgba(8, 63, 114, 1)',
        barPercentage: 0.9,
      },
      {
        data: zeros,
        label: this.translate.instant('DASHBOARD.ASSET_BREAKDOWN.DEVICES'),
        borderRadius: 5,
        borderWidth: 0,
        backgroundColor: 'rgba(106, 50, 139, 1)',
        hoverBackgroundColor: 'rgba(106, 50, 139, 1)',
        barPercentage: 0.9,
      },
    ];

    return {
      labels,
      datasets:
        isPrimary === null
          ? [...primary, ...secondary]
          : isPrimary
          ? primary
          : secondary,
    };
  }

  // formatGraphData(data: any, period: string) {
  //   let minValue = 100;
  //   let maxValue = 500;
  //   if (period === 'Monthly') {
  //     minValue = 3000;
  //     maxValue = 10000;
  //   } else if (period === 'Yearly') {
  //     minValue = 50000;
  //     maxValue = 100000;
  //   }

  //   const generateRandomData = (labelsCount: number) => {
  //     return Array.from({ length: labelsCount }, () =>
  //       Math.floor(Math.random() * (maxValue - minValue + 1)) + minValue
  //     );
  //   };

  //   const labelsCount = data?.data?.labels?.length || 0;

  //   let formatedGraphData = {
  //     labels: data?.data?.labels ? data?.data?.labels : [],
  //     datasets: [
  //       {
  //         data: generateRandomData(labelsCount),
  //         label: this.translate.instant('DASHBOARD.ASSET_BREAKDOWN.CUSTOMERS'),
  //         borderRadius: 5,
  //         borderWidth: 0,
  //         backgroundColor: 'rgba(71, 154, 63, 1)',
  //         hoverBackgroundColor: 'rgba(71, 154, 63, 1)',
  //         barPercentage: 0.9,
  //       },
  //       {
  //         data: generateRandomData(labelsCount),
  //         label: this.translate.instant('DASHBOARD.ASSET_BREAKDOWN.BUILDINGS'),
  //         borderRadius: 5,
  //         borderWidth: 0,
  //         backgroundColor: 'rgba(188, 188, 3, 1)',
  //         hoverBackgroundColor: 'rgba(188, 188, 3, 1)',
  //         barPercentage: 0.9,
  //       },
  //       {
  //         data: generateRandomData(labelsCount),
  //         label: this.translate.instant(
  //           'DASHBOARD.ASSET_BREAKDOWN.DISTRIBUTION_SUBSTATIONS'
  //         ),
  //         borderRadius: 5,
  //         borderWidth: 0,
  //         backgroundColor: 'rgba(96, 149, 27, 1)',
  //         hoverBackgroundColor: 'rgba(96, 149, 27, 1)',
  //         barPercentage: 0.9,
  //       },
  //       {
  //         data: generateRandomData(labelsCount),
  //         label: this.translate.instant('DASHBOARD.ASSET_BREAKDOWN.POLES'),
  //         borderRadius: 5,
  //         borderWidth: 0,
  //         backgroundColor: 'rgba(108, 46, 64, 1)',
  //         hoverBackgroundColor: 'rgba(108, 46, 64, 1)',
  //         barPercentage: 0.9,
  //       },
  //       {
  //         data: generateRandomData(labelsCount),
  //         label: this.translate.instant('DASHBOARD.ASSET_BREAKDOWN.TRANSMISSION_STATIONS'),
  //         borderRadius: 5,
  //         borderWidth: 0,
  //         backgroundColor: 'rgba(192, 52, 56, 1)',
  //         hoverBackgroundColor: 'rgba(192, 52, 56, 1)',
  //         barPercentage: 0.9,
  //       },
  //       {
  //         data: generateRandomData(labelsCount),
  //         label: this.translate.instant('DASHBOARD.ASSET_BREAKDOWN.INJECTION_SUBSTATIONS'),
  //         borderRadius: 5,
  //         borderWidth: 0,
  //         backgroundColor: 'rgba(237, 99, 0, 1)',
  //         hoverBackgroundColor: 'rgba(237, 99, 0, 1)',
  //         barPercentage: 0.9,
  //       },
  //       {
  //         data: generateRandomData(labelsCount),
  //         label: this.translate.instant('DASHBOARD.ASSET_BREAKDOWN.FEEDERS'),
  //         borderRadius: 5,
  //         borderWidth: 0,
  //         backgroundColor: 'rgba(8, 63, 114, 1)',
  //         hoverBackgroundColor: 'rgba(8, 63, 114, 1)',
  //         barPercentage: 0.9,
  //       },
  //       {
  //         data: generateRandomData(labelsCount),
  //         label: this.translate.instant('DASHBOARD.ASSET_BREAKDOWN.DEVICES'),
  //         borderRadius: 5,
  //         borderWidth: 0,
  //         backgroundColor: 'rgba(106, 50, 139, 1)',
  //         hoverBackgroundColor: 'rgba(106, 50, 139, 1)',
  //         barPercentage: 0.9,
  //       }
  //     ],
  //   };
  //   return formatedGraphData;
  // }
}
